import React from "react";
import StorySection from "../components/storySection";
import TeamSection from "../components/teamSection";
import AppNav from "../components/appNav";
import Footer from "../components/footer";
import Hero from "../components/hero";
import { useTranslation } from "react-i18next";

const TeamPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-paper text-ink">
      <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-[2px] border-b border-ink-14">
        <AppNav />
      </header>
      <main>
        <Hero
          title={t("A team of developers, designers, strategists.")}
          text={t("Diversity is the heartbeat of our work — humans first, technology in service.")}
        />
        <StorySection />
        <TeamSection />
        <Footer />
      </main>
    </div>
  );
};

export default TeamPage;
